import { H4, P } from "../../../AbstractElements";
import { ACTIVITY_LOG } from "../../../Data/SocialApp";
import { MyActivityProp } from "../../../Type/SocialAppType";

const MyActivity = ({ Heading }: MyActivityProp) => {
  return (
    <div className="my-activity">
      <H4 className="f-w-700 mb-3">{Heading}</H4>
      {ACTIVITY_LOG.map((item) => (
        <P key={item.id}>
          <span>{item.icon}</span>
          {item.description}
        </P>
      ))}
    </div>
  );
};

export default MyActivity;
